import React, { useEffect, useState } from "react";

import type { OfferQuantityButtonType } from "@intelligems/ig-types";
import { styled } from "@mui/material";

import { QuantityButtonContentRenderer } from "../../QuantityButtonsView/types";
import { cls } from "../../util";
import { useQuantityButtonsContext } from "../context/QuantityButtonsContext";

interface ButtonRootProps {
  button: OfferQuantityButtonType;
  selected: boolean;
  renderContent: QuantityButtonContentRenderer;
  className?: string;
}

export const ButtonRoot = ({
  button,
  selected,
  renderContent,
  className,
}: ButtonRootProps) => {
  const { calculateButtonState, onQuantityChange } =
    useQuantityButtonsContext();

  const [state, setState] = useState({
    unitDiscount: 0,
    discountedUnitPrice: "",
  });

  useEffect(() => {
    void (async () => {
      const state = await calculateButtonState(button);
      if (state) {
        setState(state);
      }
    })();
  }, [calculateButtonState, button]);

  const [hovered, setHovered] = useState<boolean>(false);
  const active = hovered || selected;

  return (
    <StyledButton
      className={cls("ig-volume-widget-button", className)}
      active={active}
      onMouseOver={() => setHovered(true)}
      onMouseOut={() => setHovered(false)}
      data-quantity={button.quantity}
      onClick={() => onQuantityChange?.(button.quantity)}
    >
      {renderContent({
        button,
        unitDiscount: state.unitDiscount,
        mode: active ? "hover" : "extra",
        discountedUnitPrice: state.discountedUnitPrice,
        originalPricePerItem: undefined,
        originalTotalPrice: undefined,
        newPricePerItem: undefined,
        newTotalPrice: undefined,
        productTitle: undefined,
        savedAmountPerItem: undefined,
        savedPercentage: undefined,
        savedTotalAmount: undefined,
        totalComparePrice: undefined,
      })}
    </StyledButton>
  );
};

interface ButtonProps {
  active: boolean;
}

const StyledButton = styled("div")(({ active }: ButtonProps) => {
  const { widget } = useQuantityButtonsContext();
  const { device, styles } = widget;
  const { colors } = styles;

  const borderColor = active ? colors.border : colors.secondary;
  const cursor = active ? "pointer" : "auto";
  return {
    display: "flex",
    flexDirection: "column",
    height: 65,
    width: device === "desktop" ? 135 : 105,
    alignItems: "center",
    borderRadius: 10,
    border: `solid 2px ${borderColor}`,
    justifyContent: "space-between",
    fontSize: device === "desktop" ? 14 : 12,
    lineHeight: `${device === "desktop" ? 14 : 12}px`,
    cursor,
  };
});
